module.exports = __webpack_public_path__ + "static/img/thumb-harvested-forestlands.8915c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-harvested-forestlands.png
// module id = 89
// module chunks = 0